;(function ($, window, document, undefined) {
    'use strict';


    function siteSearch() {

        const search = $('.site-search');

        if(search.length) {
            search.find('.col-lg-12').prepend('<h3 class="site-search__headline">Enter search topic</h3>');
            search.find('.search-field').attr('placeholder', 'Search');
            search.find('.input-group').append('<button type="submit" class="site-search__glass"><i class="icon ion-ios-search-strong" aria-hidden="true"></i></button>');
        }
    }

    $(window).on('load', function () {
        siteSearch();
    });


})(jQuery, window, document);